import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../store';
import { setFetchingEnseignants, setFilteredEnseignants, setdataFiltered } from '../../store/focusEcoleSlice';
import { Box } from '@mui/material';
import { IOptionChoisie } from '.';
import { Autocomplete, TextField, useMediaQuery, useTheme } from "@mui/material";

export interface ISearchYearProps {
    currentYear: any
    setCurrentYear: (x: any) => void;
    localDatasFiltered: any;
    setLocalDatasFiltered: (x: any) => void;
}


export default function SearchYear(props: ISearchYearProps) {
    const { localDatasFiltered, setLocalDatasFiltered, currentYear, setCurrentYear } = props

    const dispatch = useDispatch();
    const { enseignants, anneesScolaires } = useSelector((state: IReduxState) => state.focusEcole);



    return (
        <Box>
            <Autocomplete
                fullWidth
                onChange={(e: any, anScol: any) => {
                    if (anScol) {
                        setCurrentYear({
                            ...currentYear,
                            anneeScolaire: anScol.anneeScolaire
                        });
                    }
                    else {
                        setCurrentYear({})
                        dispatch(setFilteredEnseignants([...enseignants]))
                        setLocalDatasFiltered([...localDatasFiltered])
                    }
                }}
                options={anneesScolaires}
                renderOption={(props, anScol) => {
                    const { anneeScolaire } = anScol;
                    const newIndex = anneesScolaires.findIndex((item: any) => item.anneeScolaire === anneeScolaire)
                    return (
                        <span {...props}
                            style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
                        >
                            {anneeScolaire}
                        </span>
                    );
                }}

                getOptionLabel={(anScol) =>
                    `${anScol.anneeScolaire}`
                }

                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Choisir une année..."
                    />
                )}
            />
        </Box>
    );
}
